<template>
  <div>
    <div
      v-if="!registrationComplete"
      class="flex w-full flex-col gap-8 rounded-3xl"
    >
      <h2 class="text-center text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
        Dutch bat trapping and telemetry database
      </h2>
      <p class="text-center text-gray-600">
        Register your account by filling in the fields below.
      </p>

      <FormKit
        :actions="false"
        type="form"
        @submit="register"
      >
        <FormKit
          name="first_name"
          type="text"
          label="First name"
          validation="required"
        />
        <FormKit
          name="last_name"
          type="text"
          label="Last name"
          validation="required"
        />
        <FormKit
          name="email"
          type="email"
          label="Email"
          validation="required:trim|email"
          outer-class="w-full"
        />
        <UiButton
          label="Send invite"
          type="submit"
        />
      </FormKit>

      <span class="text-center text-gray-400">
        Already a member?
        <NuxtLink
          :to="{name: 'auth-login'}"
          class="font-semibold text-indigo-600"
        >
          Sign in
        </NuxtLink>
      </span>
    </div>
    <section v-else>
      <h2 class="mb-6 text-center text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
        Account registered
      </h2>
      <p class="text-center text-gray-600">
        Your account has been registered successfully. We have sent an email to the given email address to verify your
        account.
      </p>
    </section>
  </div>
</template>

<script lang="ts" setup>
import registerMutation from '~/graphql/mutations/auth/register.gql';

definePageMeta({
  auth: false,
  layout: 'auth',
  title: 'Register',
});

const registrationComplete = ref(false);

const {mutate: register, onDone} = useSofieMutation(registerMutation);
onDone(() => registrationComplete.value = true);
</script>
